import React, { useState, useEffect } from 'react';
import { getState, setState as setGlobalState, subscribe } from '../lib/userStore';
import AIAssistant from '../lib/components/AIAssistant';

const BENEFITS = {
  bcbs: {
    ppo:  { primary: '$30', telehealth: '$30', specialist: '$60', urgent: '$75', er: '$350', rx: '$10', coinsurance: '20%', oop: '$7,900', deductible: '$1,500' },
    hmo:  { primary: '$20', telehealth: '$20', specialist: '$45', urgent: '$60', er: '$300', rx: '$10', coinsurance: '20%', oop: '$6,350', deductible: '$1,500' },
    hdhp: { primary: '$0*', telehealth: '$0*', specialist: '$0*', urgent: '$0*', er: '$0*',  rx: '$15', coinsurance: '20%', oop: '$7,000', deductible: '$3,500' },
    epo:  { primary: '$25', telehealth: '$25', specialist: '$55', urgent: '$70', er: '$350', rx: '$10', coinsurance: '20%', oop: '$7,900', deductible: '$1,500' },
  },
  aetna: {
    ppo:  { primary: '$35', telehealth: '$35', specialist: '$65', urgent: '$80', er: '$400', rx: '$15', coinsurance: '20%', oop: '$8,150', deductible: '$1,500' },
    hmo:  { primary: '$25', telehealth: '$25', specialist: '$50', urgent: '$65', er: '$325', rx: '$10', coinsurance: '20%', oop: '$6,600', deductible: '$1,500' },
    hdhp: { primary: '$0*', telehealth: '$0*', specialist: '$0*', urgent: '$0*', er: '$0*',  rx: '$15', coinsurance: '20%', oop: '$7,050', deductible: '$3,500' },
    epo:  { primary: '$30', telehealth: '$30', specialist: '$60', urgent: '$75', er: '$375', rx: '$12', coinsurance: '20%', oop: '$7,900', deductible: '$1,500' },
  },
  cigna: {
    ppo:  { primary: '$30', telehealth: '$20', specialist: '$60', urgent: '$75', er: '$350', rx: '$10', coinsurance: '20%', oop: '$7,900', deductible: '$1,500' },
    hmo:  { primary: '$20', telehealth: '$10', specialist: '$45', urgent: '$60', er: '$300', rx: '$10', coinsurance: '20%', oop: '$6,000', deductible: '$1,500' },
    hdhp: { primary: '$0*', telehealth: '$0*', specialist: '$0*', urgent: '$0*', er: '$0*',  rx: '$15', coinsurance: '20%', oop: '$7,050', deductible: '$3,500' },
    epo:  { primary: '$25', telehealth: '$20', specialist: '$55', urgent: '$70', er: '$350', rx: '$10', coinsurance: '20%', oop: '$7,400', deductible: '$1,500' },
  },
  united: {
    ppo:  { primary: '$35', telehealth: '$0', specialist: '$70', urgent: '$80', er: '$400', rx: '$15', coinsurance: '20%', oop: '$8,700', deductible: '$1,500' },
    hmo:  { primary: '$25', telehealth: '$10', specialist: '$50', urgent: '$65', er: '$325', rx: '$10', coinsurance: '20%', oop: '$6,500', deductible: '$1,500' },
    hdhp: { primary: '$0*', telehealth: '$0*', specialist: '$0*', urgent: '$0*', er: '$0*',  rx: '$15', coinsurance: '20%', oop: '$7,050', deductible: '$3,500' },
    epo:  { primary: '$30', telehealth: '$10', specialist: '$60', urgent: '$75', er: '$375', rx: '$12', coinsurance: '20%', oop: '$7,900', deductible: '$1,500' },
  },
  humana: {
    ppo:  { primary: '$35', telehealth: '$0', specialist: '$65', urgent: '$75', er: '$350', rx: '$15', coinsurance: '20%', oop: '$8,150', deductible: '$1,500' },
    hmo:  { primary: '$20', telehealth: '$0', specialist: '$45', urgent: '$60', er: '$300', rx: '$10', coinsurance: '20%', oop: '$5,500', deductible: '$1,500' },
    hdhp: { primary: '$0*', telehealth: '$0*', specialist: '$0*', urgent: '$0*', er: '$0*',  rx: '$15', coinsurance: '20%', oop: '$7,050', deductible: '$3,500' },
    epo:  { primary: '$30', telehealth: '$0', specialist: '$60', urgent: '$70', er: '$350', rx: '$10', coinsurance: '20%', oop: '$7,400', deductible: '$1,500' },
  },
  medicaid: {
    ppo:  { primary: '$0', telehealth: '$0', specialist: '$3', urgent: '$3', er: '$8', rx: '$1', coinsurance: '$0', oop: 'No maximum', deductible: 'None' },
    hmo:  { primary: '$0', telehealth: '$0', specialist: '$3', urgent: '$3', er: '$8', rx: '$1', coinsurance: '$0', oop: 'No maximum', deductible: 'None' },
    hdhp: { primary: '$0', telehealth: '$0', specialist: '$3', urgent: '$3', er: '$8', rx: '$1', coinsurance: '$0', oop: 'No maximum', deductible: 'None' },
    epo:  { primary: '$0', telehealth: '$0', specialist: '$3', urgent: '$3', er: '$8', rx: '$1', coinsurance: '$0', oop: 'No maximum', deductible: 'None' },
  },
};

const CARRIER_NAMES = { bcbs: 'BlueCross BlueShield of SC', aetna: 'Aetna', cigna: 'Cigna', united: 'UnitedHealthcare', humana: 'Humana', medicaid: 'SC Medicaid', medicare: 'Medicare' };
const PLAN_NAMES    = { ppo: 'PPO', hmo: 'HMO', hdhp: 'HDHP', epo: 'EPO' };

// ─── SC Medicaid MCO options ───────────────────────────────────────────────────
const MCO_OPTIONS = [
  { value: 'absolute',    label: 'Absolute Total Care', network: 'Centene · SC Medicaid' },
  { value: 'healthy_blue',label: 'Healthy Blue',        network: 'BCBS of SC · SC Medicaid' },
  { value: 'molina',      label: 'Molina Healthcare',   network: 'Molina · SC Medicaid' },
  { value: 'wellcare',    label: 'WellCare',             network: 'Centene · SC Medicaid' },
];
const MCO_NAMES = {
  absolute: 'Absolute Total Care', healthy_blue: 'Healthy Blue',
  molina: 'Molina Healthcare',     wellcare: 'WellCare', not_sure: 'SC Medicaid',
};
const MCO_CONTACTS = [
  { name: 'Absolute Total Care', phone: '1-855-694-4678' },
  { name: 'Healthy Blue',        phone: '1-855-463-0971' },
  { name: 'Molina Healthcare',   phone: '1-855-882-3901' },
  { name: 'WellCare',            phone: '1-800-935-5292' },
];

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

export default function InsuranceScreen({ navigate, goBack, user, saveProfile, onAuthPrompt }) {
  const saved = getState();
  const [carrier, setCarrier]     = useState(saved.carrier || '');
  const [planType, setPlanType]   = useState(saved.planType || '');
  const [zip, setZip]             = useState(saved.zip || '');
  const [memberId, setMemberId]   = useState(saved.memberId || '');
  const [groupNum, setGroupNum]   = useState(saved.groupNum || '');
  const [planName, setPlanName]   = useState(saved.planName || '');
  const [cardOpen, setCardOpen]   = useState(false);
  const [cardSaved, setCardSaved] = useState(!!saved.memberId);
  const [showResults, setShowResults] = useState(!!(saved.carrier && saved.planType));
  const [cmsData, setCmsData]     = useState(null);
  const [cmsLoading, setCmsLoading] = useState(false);

  // Sync local state when Supabase profile loads asynchronously after refresh
  useEffect(() => {
    return subscribe(s => {
      if (s.carrier)  setCarrier(s.carrier);
      if (s.planType) setPlanType(s.planType);
      if (s.zip)      setZip(s.zip);
      if (s.memberId) { setMemberId(s.memberId); setCardSaved(true); }
      if (s.groupNum) setGroupNum(s.groupNum);
      if (s.planName) setPlanName(s.planName);
      if (s.carrier && s.planType) setShowResults(true);
    });
  }, []);

  // Fallback to hardcoded estimates when CMS data isn't available
  const fallbackData = carrier && planType
    ? ((BENEFITS[carrier] || BENEFITS['bcbs'])[planType] || BENEFITS['bcbs']['ppo'])
    : null;

  const data = cmsData || fallbackData;
  const dataSource = cmsData ? 'real' : 'estimate';

  async function fetchCMSBenefits(zipCode, carrierSlug, planTypeSlug) {
    if (!zipCode || zipCode.length !== 5 || !carrierSlug || !planTypeSlug) return null;
    if (planTypeSlug === 'not_sure') return null; // skip CMS; MedicaidCard shows directly
    setCmsLoading(true);
    try {
      const body = { zip: zipCode, year: 2026 };
      if (carrierSlug === 'medicaid') body.mco = planTypeSlug; // MCO hint for future key activation
      const res = await fetch(`${SUPABASE_URL}/functions/v1/get-plan-benefits`, {
        method: 'POST',
        headers: {
          'content-type': 'application/json',
          'authorization': `Bearer ${SUPABASE_KEY}`,
          'apikey': SUPABASE_KEY,
        },
        body: JSON.stringify(body),
      });
      const result = await res.json();
      if (result.fallback) return null;
      if (carrierSlug === 'medicaid' && !result.mcoFound) return null;
      return result.plans?.[`${carrierSlug}|${planTypeSlug}`] ?? null;
    } catch {
      return null;
    } finally {
      setCmsLoading(false);
    }
  }

  async function handleDecode() {
    setGlobalState({ carrier, planType, zip, memberId, groupNum, planName });
    if (user) saveProfile({ carrier, planType, zip, memberId, groupNum, planName });
    const real = await fetchCMSBenefits(zip, carrier, planType);
    setCmsData(real);
    setShowResults(true);
  }

  function handleSaveCard() {
    if (!memberId.trim()) return;
    setGlobalState({ memberId, groupNum, planName });
    if (user) saveProfile({ carrier, planType, memberId, groupNum, planName });
    setCardSaved(true);
    setCardOpen(false);
  }

  const planLabel = carrier && planType
    ? carrier === 'medicaid'
      ? `SC Medicaid · ${MCO_NAMES[planType] || planType}`
      : `${CARRIER_NAMES[carrier] || carrier} ${PLAN_NAMES[planType] || planType}`
    : '';

  return (
    <div style={s.screen}>
      {/* Header */}
      <div style={s.header}>
        <div style={{ ...s.accentBar, background: 'linear-gradient(90deg, var(--amber), #d4893f)' }} />
        <button style={s.back} onClick={goBack}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 4L6 8l4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
          Back
        </button>
        <div style={s.title}>Your coverage,<br /><em style={{ fontStyle: 'italic', color: 'var(--amber)' }}>in plain English.</em></div>
        <div style={s.subtitle}>Enter your card details for a more accurate breakdown.</div>
      </div>

      {/* Member card — pinned above scroll, always accessible */}
      <div style={s.memberCardWrap}>
        <div style={s.memberCard}>
          <div style={s.memberCardHeader}>
            <div>
              <div style={s.memberCardLabel}>Insurance card</div>
              <div style={s.memberCardTitle}>Enter your member details</div>
            </div>
            {!cardSaved && (
              <button style={s.toggleBtn} onClick={() => setCardOpen(o => !o)}>
                {cardOpen ? 'Cancel' : 'Add card'}
              </button>
            )}
            {cardSaved && (
              <button style={{ ...s.toggleBtn, color: 'var(--ink-3)' }} onClick={() => { setCardSaved(false); setCardOpen(true); }}>
                Edit
              </button>
            )}
          </div>

          {cardSaved && (
            <div style={s.savedRow}>
              <div style={s.savedIcon}>
                <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                  <path d="M3 9l4 4 8-8" stroke="var(--teal)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </div>
              <div>
                <div style={s.savedName}>Member ID: {memberId}</div>
                <div style={s.savedSub}>{groupNum ? `Group: ${groupNum} · ` : ''}{planName || 'Your plan'}</div>
              </div>
            </div>
          )}

          {cardOpen && (
            <div style={s.cardFields}>
              <div style={s.fieldGroup}>
                <div style={s.fieldLabel}>Member ID</div>
                <input style={s.input} value={memberId} onChange={e => setMemberId(e.target.value)} placeholder="e.g. XYZ123456789" />
              </div>
              <div style={{ display: 'flex', gap: '10px' }}>
                <div style={{ ...s.fieldGroup, flex: 1 }}>
                  <div style={s.fieldLabel}>Group number</div>
                  <input style={s.input} value={groupNum} onChange={e => setGroupNum(e.target.value)} placeholder="e.g. 00012345" />
                </div>
                <div style={{ ...s.fieldGroup, flex: 1 }}>
                  <div style={s.fieldLabel}>Plan name</div>
                  <input style={s.input} value={planName} onChange={e => setPlanName(e.target.value)} placeholder="e.g. Blue Value" />
                </div>
              </div>
              <button style={s.saveCardBtn} onClick={handleSaveCard}>Save my card details</button>
            </div>
          )}
        </div>
      </div>

      <div style={s.body}>
      <div style={s.bodyInner}>

        {/* Carrier select */}
        <div style={s.fieldGroup}>
          <div style={s.fieldLabel}>Insurance carrier</div>
          <div style={s.selectWrap}>
            <select style={s.select} value={carrier} onChange={e => { setCarrier(e.target.value); setShowResults(false); }}>
              <option value="">Select your carrier…</option>
              {Object.entries(CARRIER_NAMES).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
            </select>
          </div>
        </div>

        {/* Plan type — commercial carriers */}
        {carrier && carrier !== 'medicaid' && (
          <div style={s.fieldGroup}>
            <div style={s.fieldLabel}>Plan type</div>
            <div style={s.planPills}>
              {[
                { value: 'ppo',  label: 'PPO',  sub: 'Any doctor, no referral' },
                { value: 'hmo',  label: 'HMO',  sub: 'In-network, referral required' },
                { value: 'hdhp', label: 'HDHP', sub: 'Low premium, HSA-eligible' },
                { value: 'epo',  label: 'EPO',  sub: 'In-network, no referral' },
              ].map(opt => (
                <button
                  key={opt.value}
                  style={{ ...s.planPill, ...(planType === opt.value ? s.planPillActive : {}) }}
                  onClick={() => { setPlanType(opt.value); setShowResults(false); }}
                >
                  <div style={{ fontWeight: 700, fontSize: '13px' }}>{opt.label}</div>
                  <div style={{ fontSize: '10.5px', opacity: planType === opt.value ? 0.85 : 0.6, lineHeight: 1.3 }}>{opt.sub}</div>
                </button>
              ))}
            </div>
          </div>
        )}

        {/* MCO picker — SC Medicaid users */}
        {carrier === 'medicaid' && (
          <div style={s.fieldGroup}>
            <div style={s.fieldLabel}>Your Medicaid plan</div>
            <div style={s.planPills}>
              {MCO_OPTIONS.map(opt => (
                <button
                  key={opt.value}
                  style={{ ...s.mcoPill, ...(planType === opt.value ? s.planPillActive : {}) }}
                  onClick={() => { setPlanType(opt.value); setShowResults(false); setCmsData(null); }}
                >
                  <div style={{ fontWeight: 700, fontSize: '12.5px', lineHeight: 1.25, color: planType === opt.value ? 'white' : 'var(--ink)' }}>{opt.label}</div>
                  <div style={{ fontSize: '10px', opacity: planType === opt.value ? 0.7 : 0.55, lineHeight: 1.3, marginTop: '2px' }}>{opt.network}</div>
                </button>
              ))}
            </div>
            <button
              style={{ ...s.mcoNotSure, ...(planType === 'not_sure' ? s.mcoNotSureActive : {}) }}
              onClick={() => { setPlanType('not_sure'); setShowResults(false); setCmsData(null); }}
            >
              Not sure which plan I have
            </button>
            <div style={{ fontSize: '11.5px', color: 'var(--ink-4)', lineHeight: 1.55 }}>
              Check your SC Medicaid card or call 1-888-549-0820 to find your plan.
            </div>
          </div>
        )}

        {/* Zip code */}
        {carrier && planType && (
          <div style={s.fieldGroup}>
            <div style={s.fieldLabel}>Your zip code</div>
            <input
              style={s.input}
              value={zip}
              onChange={e => { setZip(e.target.value); setShowResults(false); setCmsData(null); }}
              placeholder="e.g. 29601"
              maxLength={5}
              inputMode="numeric"
            />
            <div style={{ fontSize: '11.5px', color: 'var(--ink-4)', marginTop: '2px' }}>Used to find real plan data for your area</div>
          </div>
        )}

        {/* Decode button */}
        {carrier && planType && !showResults && (
          <button style={{ ...s.decodeBtn, opacity: cmsLoading ? 0.7 : 1 }} onClick={handleDecode} disabled={cmsLoading}>
            {cmsLoading ? 'Looking up your plan…' : 'Decode my benefits →'}
          </button>
        )}

        {/* HDHP callout — commercial only */}
        {showResults && data && planType === 'hdhp' && carrier !== 'medicaid' && (
          <div style={s.hdhpCallout}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0, marginTop: '1px' }}>
              <circle cx="8" cy="8" r="7" stroke="var(--amber)" strokeWidth="1.3"/>
              <path d="M8 5v4M8 10.5v.5" stroke="var(--amber)" strokeWidth="1.3" strokeLinecap="round"/>
            </svg>
            <div style={{ fontSize: '12.5px', color: 'var(--amber)', lineHeight: 1.5 }}>
              <strong>With an HDHP, you pay full cost until your deductible is met</strong>, then {data.coinsurance} coinsurance. HSA contributions can offset these costs — contributions are tax-free.
            </div>
          </div>
        )}

        {/* SC Medicaid content card — shown when carrier is medicaid and no live CMS data */}
        {showResults && carrier === 'medicaid' && !cmsData && (
          <MedicaidCard navigate={navigate} />
        )}

        {/* Benefits card — commercial carriers, or medicaid with verified CMS data */}
        {showResults && data && (carrier !== 'medicaid' || cmsData) && (
          <>
            <div style={s.benefitsCard}>
              <div style={s.benefitsHeader}>
                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '8px' }}>
                  <div style={s.benefitsPlanLabel}>{planLabel}</div>
                  <div style={{
                    fontSize: '10px', fontWeight: 700, letterSpacing: '0.06em', textTransform: 'uppercase',
                    padding: '2px 7px', borderRadius: '100px',
                    background: dataSource === 'real' ? 'rgba(30,92,84,0.12)' : 'rgba(196,114,42,0.12)',
                    color: dataSource === 'real' ? 'var(--teal)' : 'var(--amber)',
                  }}>
                    {dataSource === 'real' ? `Verified · ${zip}` : 'Estimate'}
                  </div>
                </div>
                <div style={s.benefitsTitle}>What you'll pay</div>
              </div>

              {[
                { name: 'Primary care visit', sub: 'In-network only', val: data.primary, highlight: true },
                { name: 'Telehealth visit',   sub: 'Video or phone visit', val: data.telehealth, highlight: true },
                { name: 'Specialist visit',   sub: planType === 'hmo' ? 'Referral required' : 'In-network only', val: data.specialist },
                { name: 'Urgent care',        sub: 'In-network facility', val: data.urgent },
                { name: 'Emergency room',     sub: 'Waived if admitted', val: data.er, warn: true },
                { name: 'Generic prescription', sub: 'Tier 1 formulary', val: data.rx, highlight: true },
                { name: 'Coinsurance',        sub: 'After deductible, for covered services', val: data.coinsurance },
                { name: 'Annual deductible',  sub: 'Individual, in-network', val: data.deductible },
              ].map(row => (
                <div key={row.name} style={s.benefitRow}>
                  <div>
                    <div style={{ fontSize: '13.5px', color: 'var(--ink-2)' }}>{row.name}</div>
                    <div style={{ fontSize: '11.5px', color: 'var(--ink-4)', marginTop: '2px' }}>{row.sub}</div>
                  </div>
                  <div style={{
                    fontFamily: 'var(--font-display)',
                    fontWeight: 500,
                    fontSize: '17px',
                    letterSpacing: '-0.3px',
                    color: row.highlight ? 'var(--teal)' : row.warn ? 'var(--amber)' : 'var(--ink)',
                  }}>{row.val}</div>
                </div>
              ))}

              {/* OOP max */}
              <div style={s.oopRow}>
                <div>
                  <div style={{ fontSize: '12px', fontWeight: 600, color: 'var(--ink-3)', textTransform: 'uppercase', letterSpacing: '0.06em' }}>Your worst case this year</div>
                  <div style={{ fontSize: '11.5px', color: 'var(--ink-4)', marginTop: '2px' }}>Out-of-pocket maximum</div>
                </div>
                <div style={{ fontFamily: 'var(--font-display)', fontWeight: 500, fontSize: '17px', letterSpacing: '-0.3px', color: 'var(--ink)' }}>{data.oop}</div>
              </div>
            </div>

            <div style={s.tip}>
              {dataSource === 'real'
                ? <>✓ <strong>Data sourced from federal marketplace plans for zip {zip}.</strong> Costs shown are for individual market plans. Employer-sponsored plans may differ — call the member number on your card to confirm.</>
                : <>💡 <strong>Estimates based on typical plan structures.</strong> Enter your zip code above for real plan data in your area. Actual costs depend on your specific plan documents.</>
              }
            </div>
          </>
        )}

        {/* AI assistant + signup nudge + handoff — shown for all result types */}
        {showResults && (data || (carrier === 'medicaid' && !cmsData)) && (
          <>
            <AIAssistant
              placeholder="Ask about your coverage, copays, or referrals…"
              starterPrompts={
                carrier === 'medicaid'
                  ? [
                      'What does Medicaid cover for dental?',
                      'Do I need a referral to see a specialist?',
                      'How do I find a Medicaid provider near me?',
                      'What prescriptions does Medicaid cover?',
                    ]
                  : [
                      planType === 'hmo' ? 'Do I need a referral to see a specialist?' : 'Is physical therapy covered under my plan?',
                      'What does my deductible mean?',
                      `What's my copay for urgent care?`,
                      'Does my plan cover mental health visits?',
                    ]
              }
            />

            {/* Signup nudge — anon users only */}
            {!user && onAuthPrompt && (
              <div style={s.signupNudge}>
                <div style={s.signupNudgeTitle}>Save your plan</div>
                <p style={s.signupNudgeText}>Create a free account to save your insurance and access your costs without re-entering anything.</p>
                <button style={s.signupNudgeBtn} onClick={onAuthPrompt}>Save my plan — it's free →</button>
              </div>
            )}

            {/* Handoff */}
            <div style={s.handoff}>
              <div style={s.handoffInner}>
                <div style={s.handoffLabel}>Ready for the next step?</div>
                <p style={s.handoffText}>
                  {carrier === 'medicaid'
                    ? "Let's find Medicaid providers in Greenville who are accepting patients near you."
                    : "Now that you know what you'll pay, let's find a doctor in Greenville who takes your plan."}
                </p>
                <button style={s.handoffBtn} onClick={() => navigate('findCare')}>
                  Find a doctor near you
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" style={{ flexShrink: 0 }}>
                    <path d="M6 4l4 4-4 4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                </button>
              </div>
            </div>
          </>
        )}

        <div style={{ height: '24px' }} />
      </div>
      </div>
    </div>
  );
}

const s = {
  screen: { flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column', overflow: 'hidden', background: 'var(--cream)' },
  header: { padding: '52px 24px 20px', background: 'var(--surface)', borderBottom: '1px solid var(--border)', position: 'relative', flexShrink: 0 },
  accentBar: { position: 'absolute', top: 0, left: 0, right: 0, height: '3px' },
  back: { display: 'flex', alignItems: 'center', gap: '6px', fontSize: '13px', fontWeight: 500, color: 'var(--ink-3)', cursor: 'pointer', marginBottom: '16px', background: 'none', border: 'none', padding: 0, fontFamily: 'var(--font-body)' },
  title: { fontFamily: 'var(--font-display)', fontWeight: 400, fontSize: '26px', color: 'var(--ink)', letterSpacing: '-0.5px', lineHeight: 1.2 },
  subtitle: { fontSize: '13.5px', color: 'var(--ink-3)', marginTop: '6px', lineHeight: 1.5 },
  body: { flex: 1, minHeight: 0, overflowY: 'auto', msOverflowStyle: 'none', scrollbarWidth: 'none' },
  bodyInner: { display: 'flex', flexDirection: 'column', gap: '16px', padding: '24px' },
  memberCardWrap: { padding: '16px 24px 0', flexShrink: 0, background: 'var(--cream)' },
  memberCard: { background: 'var(--surface)', borderRadius: 'var(--radius-lg)', border: '1px solid var(--border)', overflow: 'hidden' },
  memberCardHeader: { padding: '14px 18px', background: 'var(--amber-light)', borderBottom: '1px solid rgba(196,114,42,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  memberCardLabel: { fontSize: '10.5px', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--amber)', marginBottom: '2px' },
  memberCardTitle: { fontFamily: 'var(--font-display)', fontWeight: 400, fontSize: '15px', color: 'var(--ink)' },
  toggleBtn: { fontSize: '12px', fontWeight: 600, color: 'var(--amber)', cursor: 'pointer', padding: '4px 8px', borderRadius: 'var(--radius-sm)', background: 'none', border: 'none', fontFamily: 'var(--font-body)' },
  savedRow: { padding: '14px 18px', display: 'flex', alignItems: 'center', gap: '12px' },
  savedIcon: { width: '36px', height: '36px', borderRadius: '50%', background: 'var(--teal-faint)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 },
  savedName: { fontSize: '14px', fontWeight: 600, color: 'var(--ink)', marginBottom: '1px' },
  savedSub: { fontSize: '12px', color: 'var(--ink-3)' },
  cardFields: { padding: '16px 18px', display: 'flex', flexDirection: 'column', gap: '12px' },
  fieldGroup: { display: 'flex', flexDirection: 'column', gap: '6px' },
  fieldLabel: { fontSize: '12px', fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase', color: 'var(--ink-3)' },
  input: { width: '100%', padding: '13px 16px', borderRadius: 'var(--radius-md)', border: '1.5px solid var(--border-strong)', background: 'var(--surface)', fontFamily: 'var(--font-body)', fontSize: '14px', color: 'var(--ink)', outline: 'none' },
  saveCardBtn: { width: '100%', padding: '13px 18px', borderRadius: 'var(--radius-md)', border: 'none', background: 'var(--amber)', color: 'white', fontFamily: 'var(--font-body)', fontSize: '14px', fontWeight: 600, cursor: 'pointer' },
  selectWrap: { position: 'relative' },
  select: { width: '100%', padding: '13px 16px', borderRadius: 'var(--radius-md)', border: '1.5px solid var(--border-strong)', background: 'var(--surface)', fontFamily: 'var(--font-body)', fontSize: '14px', color: 'var(--ink)', outline: 'none', appearance: 'none' },
  decodeBtn: { width: '100%', padding: '16px 20px', borderRadius: 'var(--radius-md)', border: 'none', background: 'var(--amber)', color: 'white', fontFamily: 'var(--font-body)', fontSize: '15px', fontWeight: 600, cursor: 'pointer' },
  benefitsCard: { background: 'var(--surface)', borderRadius: 'var(--radius-lg)', border: '1px solid var(--border)', boxShadow: 'var(--shadow-card)', overflow: 'hidden' },
  benefitsHeader: { padding: '18px 20px', background: 'var(--amber-light)', borderBottom: '1px solid rgba(196,114,42,0.15)' },
  benefitsPlanLabel: { fontSize: '11px', color: 'var(--amber)', fontWeight: 600, letterSpacing: '0.06em', textTransform: 'uppercase' },
  benefitsTitle: { fontFamily: 'var(--font-display)', fontWeight: 500, fontSize: '16px', color: 'var(--ink)', letterSpacing: '-0.2px' },
  benefitRow: { padding: '14px 20px', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '12px', borderBottom: '1px solid var(--border)' },
  tip: { padding: '14px 18px', background: 'var(--teal-faint)', borderRadius: 'var(--radius-md)', border: '1px solid rgba(30,92,84,0.12)', fontSize: '12.5px', color: 'var(--ink-2)', lineHeight: 1.5 },
  handoff: { borderRadius: 'var(--radius-lg)', overflow: 'hidden', border: '1px solid rgba(30,92,84,0.18)', background: 'var(--teal-faint)' },
  handoffInner: { padding: '16px 18px' },
  handoffLabel: { fontSize: '10.5px', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--teal)', marginBottom: '4px' },
  handoffText: { fontSize: '13px', color: 'var(--ink-2)', lineHeight: 1.5, marginBottom: '12px' },
  handoffBtn: { width: '100%', padding: '13px 18px', background: 'var(--teal)', color: 'white', border: 'none', borderRadius: 'var(--radius-md)', fontFamily: 'var(--font-body)', fontSize: '14px', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' },
  signupNudge:     { background: 'var(--surface)', borderRadius: 'var(--radius-lg)', border: '1px solid var(--border)', padding: '16px 18px', display: 'flex', flexDirection: 'column', gap: '8px' },
  signupNudgeTitle:{ fontSize: '13.5px', fontWeight: 600, color: 'var(--ink)' },
  signupNudgeText: { fontSize: '12px', color: 'var(--ink-3)', lineHeight: 1.5, margin: 0 },
  signupNudgeBtn:  { padding: '12px 16px', borderRadius: 'var(--radius-md)', background: 'var(--amber)', color: 'white', fontFamily: 'var(--font-body)', fontSize: '13px', fontWeight: 600, border: 'none', cursor: 'pointer' },
  // Plan type pills
  planPills: { display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' },
  planPill: { padding: '10px 12px', borderRadius: 'var(--radius-md)', border: '1.5px solid var(--border-strong)', background: 'var(--surface)', fontFamily: 'var(--font-body)', color: 'var(--ink)', cursor: 'pointer', textAlign: 'left', display: 'flex', flexDirection: 'column', gap: '2px' },
  planPillActive: { background: 'var(--teal)', border: '1.5px solid var(--teal)', color: 'white' },
  // MCO pills (same grid, teal active to differentiate from plan type amber)
  mcoPill: { padding: '11px 13px', borderRadius: 'var(--radius-md)', border: '1.5px solid var(--border-strong)', background: 'var(--surface)', fontFamily: 'var(--font-body)', color: 'var(--ink)', cursor: 'pointer', textAlign: 'left', display: 'flex', flexDirection: 'column', gap: '3px' },
  mcoNotSure: { width: '100%', padding: '10px 16px', borderRadius: 'var(--radius-md)', border: '1.5px solid var(--border)', background: 'var(--surface-2)', fontFamily: 'var(--font-body)', fontSize: '13px', color: 'var(--ink-3)', cursor: 'pointer', textAlign: 'center' },
  mcoNotSureActive: { background: 'var(--teal)', border: '1.5px solid var(--teal)', color: 'white' },
  // HDHP callout
  hdhpCallout: { display: 'flex', gap: '10px', alignItems: 'flex-start', padding: '14px 16px', background: 'var(--amber-light)', borderRadius: 'var(--radius-md)', border: '1px solid rgba(196,114,42,0.2)' },
  // OOP max row
  oopRow: { padding: '14px 20px', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '12px', background: 'var(--cream-2)', borderTop: '1px solid var(--border)' },
};

// ─── MedicaidCard — SC Medicaid fallback content ───────────────────────────────
function MedicaidCard({ navigate }) {
  const MEDICAID_ROWS = [
    { name: 'Primary care visit',    sub: 'In-network provider',  val: '$0',  highlight: true },
    { name: 'Telehealth visit',      sub: 'Video or phone visit', val: '$0',  highlight: true },
    { name: 'Specialist visit',      sub: 'In-network provider',  val: '$3' },
    { name: 'Urgent care',           sub: 'Walk-in clinic',       val: '$3' },
    { name: 'Emergency room',        sub: 'Waived if admitted',   val: '$8',  warn: true },
    { name: 'Generic prescriptions', sub: 'Tier 1 formulary',     val: '$1',  highlight: true },
    { name: 'Annual deductible',     sub: 'No deductible',        val: 'None', muted: true },
  ];
  return (
    <div style={ms.card}>
      {/* Header */}
      <div style={ms.header}>
        <div style={ms.headerIcon}>🏥</div>
        <div style={{ flex: 1 }}>
          <div style={ms.headerPlan}>SC Medicaid · Healthy Connections</div>
          <div style={ms.headerTitle}>What you'll pay</div>
        </div>
        <div style={ms.headerBadge}>SC 2026</div>
      </div>

      {/* $0 hero */}
      <div style={ms.zeroHero}>
        <div style={ms.zeroAmount}>$0</div>
        <div>
          <div style={{ fontSize: '13.5px', fontWeight: 700, color: 'var(--ink)', marginBottom: '2px' }}>Primary care visits</div>
          <div style={{ fontSize: '11.5px', color: 'var(--ink-3)', lineHeight: 1.4 }}>No copay to see your doctor or use telehealth</div>
        </div>
      </div>

      {/* Benefit rows */}
      {MEDICAID_ROWS.map(row => (
        <div key={row.name} style={ms.row}>
          <div>
            <div style={{ fontSize: '13px', color: 'var(--ink-2)' }}>{row.name}</div>
            <div style={{ fontSize: '11px', color: 'var(--ink-4)', marginTop: '1px' }}>{row.sub}</div>
          </div>
          <div style={{
            fontFamily: row.muted ? 'var(--font-body)' : 'var(--font-display)',
            fontWeight: row.muted ? 600 : 500,
            fontSize: row.muted ? '13px' : '16px',
            letterSpacing: '-0.3px',
            flexShrink: 0,
            color: row.muted ? 'var(--ink-3)' : row.warn ? 'var(--amber)' : 'var(--teal)',
          }}>{row.val}</div>
        </div>
      ))}

      {/* MCO contacts */}
      <div style={ms.contacts}>
        <div style={ms.contactsLabel}>Member services by plan</div>
        {MCO_CONTACTS.map(c => (
          <div key={c.name} style={ms.contactRow}>
            <span style={{ fontSize: '12px', fontWeight: 600, color: 'var(--ink-2)' }}>{c.name}</span>
            <span style={{ fontSize: '11.5px', fontWeight: 600, color: 'var(--amber)' }}>{c.phone}</span>
          </div>
        ))}
      </div>

      {/* CTA */}
      <div style={{ padding: '13px 18px' }}>
        <button style={ms.ctaBtn} onClick={() => navigate('findCare')}>
          Find Medicaid providers near you
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" style={{ flexShrink: 0 }}>
            <path d="M5 3l4 4-4 4" stroke="white" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
      </div>
      <div style={{ padding: '0 18px 13px', fontSize: '11px', color: 'var(--ink-4)', lineHeight: 1.5 }}>
        Copays shown are standard SC Medicaid amounts. Your MCO may vary — call member services to confirm.
      </div>
    </div>
  );
}

const ms = {
  card:          { background: 'var(--surface)', borderRadius: 'var(--radius-lg)', border: '1px solid var(--border)', boxShadow: 'var(--shadow-card)', overflow: 'hidden' },
  header:        { padding: '15px 18px', background: 'var(--amber-light)', borderBottom: '1px solid rgba(196,114,42,0.14)', display: 'flex', alignItems: 'center', gap: '11px' },
  headerIcon:    { width: '34px', height: '34px', borderRadius: '9px', background: 'rgba(196,114,42,0.13)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '16px', flexShrink: 0 },
  headerPlan:    { fontSize: '10px', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--amber)', marginBottom: '2px' },
  headerTitle:   { fontFamily: 'var(--font-display)', fontWeight: 500, fontSize: '14.5px', color: 'var(--ink)', letterSpacing: '-0.2px' },
  headerBadge:   { fontSize: '10px', fontWeight: 700, letterSpacing: '0.04em', textTransform: 'uppercase', padding: '3px 8px', borderRadius: '100px', background: 'rgba(30,92,84,0.1)', color: 'var(--teal)', whiteSpace: 'nowrap', flexShrink: 0 },
  zeroHero:      { padding: '15px 18px', background: 'var(--teal-faint)', borderBottom: '1px solid rgba(30,92,84,0.1)', display: 'flex', alignItems: 'center', gap: '14px' },
  zeroAmount:    { fontFamily: 'var(--font-display)', fontSize: '38px', fontWeight: 600, color: 'var(--teal)', letterSpacing: '-1.5px', lineHeight: 1, flexShrink: 0 },
  row:           { padding: '11px 18px', display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: '10px', borderBottom: '1px solid var(--border)' },
  contacts:      { padding: '12px 18px', background: 'var(--surface-2)', borderBottom: '1px solid var(--border)' },
  contactsLabel: { fontSize: '10px', fontWeight: 700, letterSpacing: '0.1em', textTransform: 'uppercase', color: 'var(--ink-3)', marginBottom: '8px' },
  contactRow:    { display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '5px 0', gap: '8px' },
  ctaBtn:        { width: '100%', padding: '12px 18px', background: 'var(--teal)', color: 'white', border: 'none', borderRadius: 'var(--radius-md)', fontFamily: 'var(--font-body)', fontSize: '13.5px', fontWeight: 600, cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px' },
};